// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Overview-module__ui-Overview--zfiqM {
  width: 100%;
  padding-bottom: 48px;
  box-sizing: border-box;
}

.Overview-module__wrap--oP_FB {
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: center;
  gap: 40px;
  box-sizing: border-box;
}

.Overview-module__ui-Overview-Content--pXGuk {
  display: flex;
  width: 430px;
  max-width: 100%;
  flex-direction: column;
  align-items: flex-start;
  gap: 20px;
  box-sizing: border-box;
}

.Overview-module__title--c4DIU {
  width: 100%;
  color: var(--chaek-color-text-primary);
  font-size: 3rem; /* 48px */
  line-height: 64px;
  letter-spacing: -1.1011px;
  text-align: center;
  overflow-wrap: anywhere;
}

.Overview-module__content--Mf0D8 {
  color: var(--chaek-color-text-muted);
  font-size: 0.8125rem; /* 13px */
  line-height: 19.5px;
  letter-spacing: -0.4262px;
  overflow-wrap: anywhere;
}

.Overview-module__description--zEHDx {
  color: var(--chaek-color-text-secondary);
  font-size: 1rem; /* 16px */
  line-height: 24px;
  letter-spacing: -0.7625px;
  overflow-wrap: anywhere;
}

.Overview-module__meta--Ql5ag {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  color: var(--chaek-color-text-primary);
  font-size: 0.625rem; /* 10px */
  line-height: 16px;
  letter-spacing: -0.2328px;
  overflow-wrap: anywhere;
}

.Overview-module__meta--Ql5ag > * {
  padding: 7px 10px 8px;
  border-radius: 14px;
  background: var(--chaek-color-surface-subtle);
  box-shadow: inset 0 0 0 1px var(--chaek-color-border-divider);
  color: var(--chaek-color-text-primary);
  box-sizing: border-box;
}

.Overview-module__ui-Overview-Media--HtOZ2 {
  display: flex;
  width: 100%;
  flex: 0 0 auto;
  align-items: center;
  justify-content: center;
}

.Overview-module__ui-Overview-Media--HtOZ2 .Overview-module__box--QyunB {
  padding: 20px;
  background: #fcfaf7;
  box-shadow: 0 2px 3px rgb(0 0 0 / 14%);
  box-sizing: border-box;
}

.Overview-module__ui-Overview-Media--HtOZ2 .Overview-module__box--QyunB > * {
  width: 100%;
}

.Overview-module__ui-Overview-Media--HtOZ2 :where(img) {
  display: block;
  width: 100%;
  height: auto;
}
`, "",{"version":3,"sources":["webpack://./../../packages/design-system/src/components/Overview/Overview.module.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,eAAe;EACf,sBAAsB;EACtB,uBAAuB;EACvB,SAAS;EACT,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,sCAAsC;EACtC,eAAe,EAAE,SAAS;EAC1B,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;EACpC,oBAAoB,EAAE,SAAS;EAC/B,mBAAmB;EACnB,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;EACE,wCAAwC;EACxC,eAAe,EAAE,SAAS;EAC1B,iBAAiB;EACjB,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,sCAAsC;EACtC,mBAAmB,EAAE,SAAS;EAC9B,iBAAiB;EACjB,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,6CAA6C;EAC7C,6DAA6D;EAC7D,sCAAsC;EACtC,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,cAAc;EACd,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sCAAsC;EACtC,sBAAsB;AACxB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;AACd","sourcesContent":[".ui-Overview {\n  width: 100%;\n  padding-bottom: 48px;\n  box-sizing: border-box;\n}\n\n.wrap {\n  display: flex;\n  width: 100%;\n  flex-direction: column;\n  align-items: center;\n  gap: 40px;\n  box-sizing: border-box;\n}\n\n.ui-Overview-Content {\n  display: flex;\n  width: 430px;\n  max-width: 100%;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 20px;\n  box-sizing: border-box;\n}\n\n.title {\n  width: 100%;\n  color: var(--chaek-color-text-primary);\n  font-size: 3rem; /* 48px */\n  line-height: 64px;\n  letter-spacing: -1.1011px;\n  text-align: center;\n  overflow-wrap: anywhere;\n}\n\n.content {\n  color: var(--chaek-color-text-muted);\n  font-size: 0.8125rem; /* 13px */\n  line-height: 19.5px;\n  letter-spacing: -0.4262px;\n  overflow-wrap: anywhere;\n}\n\n.description {\n  color: var(--chaek-color-text-secondary);\n  font-size: 1rem; /* 16px */\n  line-height: 24px;\n  letter-spacing: -0.7625px;\n  overflow-wrap: anywhere;\n}\n\n.meta {\n  display: flex;\n  align-items: flex-start;\n  gap: 8px;\n  color: var(--chaek-color-text-primary);\n  font-size: 0.625rem; /* 10px */\n  line-height: 16px;\n  letter-spacing: -0.2328px;\n  overflow-wrap: anywhere;\n}\n\n.meta > * {\n  padding: 7px 10px 8px;\n  border-radius: 14px;\n  background: var(--chaek-color-surface-subtle);\n  box-shadow: inset 0 0 0 1px var(--chaek-color-border-divider);\n  color: var(--chaek-color-text-primary);\n  box-sizing: border-box;\n}\n\n.ui-Overview-Media {\n  display: flex;\n  width: 100%;\n  flex: 0 0 auto;\n  align-items: center;\n  justify-content: center;\n}\n\n.ui-Overview-Media .box {\n  padding: 20px;\n  background: #fcfaf7;\n  box-shadow: 0 2px 3px rgb(0 0 0 / 14%);\n  box-sizing: border-box;\n}\n\n.ui-Overview-Media .box > * {\n  width: 100%;\n}\n\n.ui-Overview-Media :where(img) {\n  display: block;\n  width: 100%;\n  height: auto;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"ui-Overview": `Overview-module__ui-Overview--zfiqM`,
	"wrap": `Overview-module__wrap--oP_FB`,
	"ui-Overview-Content": `Overview-module__ui-Overview-Content--pXGuk`,
	"title": `Overview-module__title--c4DIU`,
	"content": `Overview-module__content--Mf0D8`,
	"description": `Overview-module__description--zEHDx`,
	"meta": `Overview-module__meta--Ql5ag`,
	"ui-Overview-Media": `Overview-module__ui-Overview-Media--HtOZ2`,
	"box": `Overview-module__box--QyunB`
};
export default ___CSS_LOADER_EXPORT___;
